import * as yup from 'yup';

export default yup.object({
  estimatedMonthOfDelivery: yup.string().required(),
  plate: yup.string().required(),
  brand: yup.string().required(),
  model: yup.string().required(),
  edition: yup.string().required(),
  displacement: yup.string().required(),
  powerHp: yup.string().required(),
  mileageFromOdometer: yup.string().required(),
  transmission: yup.string().required(),
  fuelType: yup.string().required(),
  year: yup.string().required(),
  color: yup.string().required(),
  price: yup.string().required(),
});
